export const role = {
  guest: "ROLE_GUEST",
  readOnly: "ROLE_READ_ONLY",
  client: "ROLE_CLIENT",
  user: "ROLE_USER",
  crm: "ROLE_CRM",
  compareRatesOnly: "ROLE_COMPARE_RATES_ONLY",
  salesIndividualView: "ROLE_SALES_INDIVIDUAL_VIEW",
  salesTeamView: "ROLE_SALES_TEAM_VIEW",
  customerService: "ROLE_CUSTOMER_SERVICE",
  pricingManager: "ROLE_PRICING_MANAGER",
  organizationAdmin: "ROLE_ORGANIZATION_ADMIN",
  superAdmin: "ROLE_SUPER_ADMIN",
  previousAdmin: "ROLE_PREVIOUS_ADMIN",
};

export const roleDefinition = {
  guest: [role.guest],
  compareRatesOnly: [role.compareRatesOnly],
  readOnly: [role.readOnly],
  user: [role.user],
  sales: [
    role.salesIndividualView,
    role.salesTeamView,
    role.pricingManager,
    role.organizationAdmin,
  ],
  pricingManager: [role.pricingManager, role.organizationAdmin],
  organizationAdmin: [role.organizationAdmin],
  superAdmin: [role.superAdmin],
  previousAdmin: [role.previousAdmin],
};

export const groupList = Object.keys(roleDefinition);
